// extracted by mini-css-extract-plugin
module.exports = {"teaser":"teaserNa_teaser__wuFsF"};